import { ENDPOINTS_COMPETITIONS, ENDPOINTS_TEAMS, ENDPOINTS_USER } from '../config';
import { Competition } from '../components/Competitions/CompetitionsTypes';
import moment from 'moment';
import { Check } from '../components/AlphaTestingStatus/TestingStatus/types';
import { CHALLENGE_COMPETITION_ID } from '../shared/constants';

export interface PerformanceEndpointParameters {
  alphaId: string;
  teamId?: string;
  scoringCompetition?: string;
}

export function getPerformanceEndpoint({ alphaId, teamId, scoringCompetition }: PerformanceEndpointParameters) {
  if (scoringCompetition) {
    return `${ENDPOINTS_COMPETITIONS.competitions}/${scoringCompetition}/alphas/${alphaId}/before-and-after-performance`;
  }
  return teamId === undefined
    ? `${ENDPOINTS_USER.user}/self/alphas/${alphaId}/before-and-after-performance`
    : `${ENDPOINTS_TEAMS.teams}/${teamId}/alphas/${alphaId}/before-and-after-performance`;
}

export function getIsCompetitionRunning(competition: Competition) {
  const { startDate, endDate } = competition;
  const now = moment.now();
  return (startDate == null || moment(startDate).isBefore(now)) && (endDate == null || moment(endDate).isAfter(now));
}

const getAlphaISChecks = (alphaData: any, alphaId: string | null): Check[] => {
  const alpha = alphaData?.has('children')
    ? alphaData.get('children').find((data: any) => data.getIn(['alphaDetail', 'id']) === alphaId)
    : alphaData;
  const checks = alpha?.getIn(['alphaDetail', 'is', 'checks'])?.toJS() as Check[];
  return checks ?? [];
};

export function getScoringCompetition(state: any, alphaData: any, alphaId: string | null) {
  const competitions = state.getIn(['competitions', 'userCompetitions', 'results'])?.toJS() as Competition[];
  const checks = getAlphaISChecks(alphaData, alphaId);
  const competitionCheckIds = checks
    .filter(
      check =>
        check.name === 'MATCHES_COMPETITION' &&
        (check.result === 'PASS' || check.result === 'PENDING') &&
        (check.competitions ?? check.matched)
    )
    .flatMap(check =>
      (check.competitions ?? check.matched ?? [])
        // Unlike other competitions, AIACv2 is considered as scoring competition even if its check is PENDING
        .filter(competition => check.result === 'PASS' || (check.result === 'PENDING' && competition.id === 'AIACv2'))
        .map(match => match.id)
    );
  const competitionIdsSet = new Set(competitionCheckIds);

  if (!competitions || competitionIdsSet.size === 0) {
    return;
  }
  const scoringCompetition = competitions.find(
    competition =>
      competition.id !== CHALLENGE_COMPETITION_ID &&
      competition.scoring === 'PERFORMANCE' &&
      competition.status === 'ACCEPTED' &&
      competitionIdsSet.has(competition.id) &&
      getIsCompetitionRunning(competition)
  );

  return scoringCompetition?.id;
}
